import { Injectable } from '@angular/core';
import { AdminDashboard } from '@models';
import { ItemRecord } from '@controladad/ng-base';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApi } from './_base-api';

@Injectable({ providedIn: 'root' })
export class DashboardApiService extends BaseApi<any> {
  constructor() {
    super('/AdminPanel/GetAdminDashboard');
  }

  getAdminDashboard(from?: string, to?: string, vendors?: number[]) {
    const params = new URLSearchParams();
    if (from) params.set('From', from);
    if (to) params.set('To', to);
    if (vendors && vendors.length > 0) {
      vendors.forEach(vendorId => params.append('Vendors', vendorId.toString()));
    }
    const qs = params.toString();
    const url = `/AdminPanel/GetAdminDashboard${qs ? `?${qs}` : ''}`;
    return http$.get<AdminDashboard>(url);
  }

  getVendorItems(): Observable<ItemRecord<number>[]> {
    return super
      .getAll<{ id: number; vendorName: string }>(undefined, '/AdminPanel/GetVendorList')
      .pipe(map((vendors) => vendors.map((v: { id: number; vendorName: string }) => ({ label: v.vendorName, value: v.id }))));
  }
}


